import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Timesheet } from './timesheet';
import { TimesheetEntry, TimesheetExpense } from './timesheetEntry';

@JsonObject('TimesheetSearchResults')
export class TimesheetSearchResults extends SearchResults {
    @JsonProperty('results', [Timesheet])
    results: Timesheet[] = [];
}

@JsonObject('TimesheetEntrySearchResults')
export class TimesheetEntrySearchResults extends SearchResults {
    @JsonProperty('results', [TimesheetEntry])
    results: TimesheetEntry[] = [];

    @JsonProperty('pending', Number, true)
    pending: number = undefined;

    @JsonProperty('invoiced', Number, true)
    invoiced: number = undefined;

    @JsonProperty('paid', Number, true)
    paid: number = undefined;
}

@JsonObject('TimesheetExpenseSearchResults')
export class TimesheetExpenseSearchResults extends SearchResults {
    @JsonProperty('results', [TimesheetExpense])
    results: TimesheetExpense[] = [];
}

@JsonObject('FileTimesheet')
export class FileTimesheet {
    @JsonProperty('entries', [TimesheetEntry])
    entries: TimesheetEntry[] = [];

    @JsonProperty('expenses', [TimesheetExpense])
    expenses: TimesheetExpense[] = [];

    @JsonProperty('totals', Number, true)
    totals: number = undefined;

    @JsonProperty('issued_invoices', Number, true)
    issuedInvoices: number = undefined;

    @JsonProperty('pending_ammount', Number, true)
    pendingAmmount: number = undefined;

    @JsonProperty('amount_paid', Number, true)
    amountPaid: number = undefined;
}